document.addEventListener("DOMContentLoaded", () => {
  const accordions = document.querySelectorAll(".product__custom__accrdion");

  accordions.forEach((accordion) => {
    const title = accordion.querySelector(".product__custom__accordion__title");
    const frame = accordion.querySelector(".product__custom__accordion__frame");

    if (!title || !frame) return;

    title.addEventListener("click", () => {
      title.classList.toggle("is-active");
      frame.classList.toggle("is-active");
    });
  });
});